module.exports = __webpack_public_path__ + "img/fuel.7df8b9d5.png";